export const EMPLOYEE_DESIGNATION = {
  SUPPORT: 'Support',
};
